import React from 'react';
import { Redirect } from 'react-router';
import icons from '../../icons';
import style from './Offline.module.css';

import { auth } from '../../firebase';
import { signOut } from 'firebase/auth';
import urls from '../../urls';


export default class Offline extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            offline: true,
            offlineNotAvailable: true,
        };
    };

    async componentDidMount() {
        window.addEventListener('online', () => this.setState({ offline: !navigator.onLine }));
        window.addEventListener('offline', () => this.setState({ offline: !navigator.onLine }));
    };

    componentWillUnmount() {
        window.removeEventListener('online', () => this.setState({ offline: !navigator.onLine }));
        window.removeEventListener('offline', () => this.setState({ offline: !navigator.onLine }));
    }

    render() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (!this.state.offline && !this.props.errorPage) return <Redirect to="/" />;
        return(
            <main className={ style.main }>
                { this.state.offlineNotAvailable && !urlParams.get("partial") ? 
                    <h1 className={ style.header }>Nessun backup dei dati per la modalità offline trovato sul tuo dispositivo</h1> : 
                    <>
                        <h1 className={ style.header }>SEI OFFLINE</h1>
                        <h3 className={ style.details }>Puoi vedere solo le pagine che hai già visitato mentre eri online</h3>
                    </> 
                }
                <img alt="" className={ style.icon } src={ icons.disconnected_icon }></img>
                <h1 className={ style.details }>Se vedi questa pagina anche se sei online, prova ad effettuare il login di nuovo:</h1>
                <div className={ style.btnLogin } onClick={ async () => {
                    try {
                        localStorage.removeItem("userData");
                        localStorage.removeItem("loggedInClassroom");
                        fetch(urls.unsubscribe, {     
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({ userId: JSON.parse(localStorage.getItem("userData").id) }),
                        }).catch();
                        fetch(urls.googleAuthTokenRevoke, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                userId: JSON.parse(localStorage.getItem("userData").id)
                            })
                        }).catch();
                    } catch (err) {} 
                    signOut(auth).catch().finally(() => window.location.href = "/login");
                }} >
                    <img alt="" src={ icons.lock_white_icon }/>
                    <h3>VAI AL LOGIN</h3>
                </div>
            </main>
        );
    };
};